export class GetMemberNewsSearchRequest {
    constructor(memberId, timeFrame, searchText, pagenum) {
        if (memberId == 0)
            this.memberId = null;
        else
            this.memberId = memberId;
        this.pageNum = pagenum;
        this.TimeFrame = timeFrame;
        this.searchText = searchText
    }
    pageNum: number;
    searchText: string;
    TimeFrame: number;
    memberId: string;
}
